export default {
  zh: {
    brand: {
      name: '诺瓦智检'
    },
    nav: {
      items: [
        { id: 'hero', label: '首页' },
        { id: 'about', label: '关于我们' },
        { id: 'business', label: '核心业务' },
        { id: 'product-services', label: '产品服务' },
        { id: 'products', label: '产品架构' },
        { id: 'news', label: '新闻资讯' }
      ],
      contact: '联系我们',
      languageSwitch: '语言切换',
      locales: [
        { value: 'zh', label: '中文' },
        { value: 'en', label: 'EN' }
      ]
    },
    hero: {
      badge: 'AI审核+PBRTQC+预测数字孪生 融合创新',
      titleLine1: '重塑医疗检验',
      titleHighlight: '智能未来',
      desc: '诺瓦智检以人工智能为驱动，整合精准检验技术与智慧医疗解决方案，为医疗机构、科研院所提供全链路智能化服务，助力健康中国建设与智能化发展。',
      primaryCta: '探索核心业务',
      secondaryCta: '了解更多',
      aiAuditTitle: 'AI审核',
      aiAuditDesc: '智能审核，高效识别，结果可信',
      accuracy: '精准率',
      twinTitle: '预测与数字孪生',
      twinDesc: '覆盖多项指标',
      pbrtqcDesc: '实时质控',
      scrollHint: '向下滚动'
    },
    about: {
      eyebrow: 'ABOUT US',
      titlePrefix: '垂直医检领域',
      titleHighlight: '匠心深耕',
      desc: '凯驰医疗集团与北京协和医院达成战略合作，共同打造诺瓦智检产品。凯驰医疗集团发挥子公司（诺瓦智检）其在医疗检验综合服务平台的技术转化、渠道覆盖和工程服务优势。双方深度融合“医工协同”，将协和检验科的专家规则与诺瓦智检的AI算法、软件研发能力结合，研发出以“检验科AI审核、PBRTQC质控、预测分析、数字孪生”为核心功能的诺瓦智检系统，旨在提升检验结果审核效率与质量，推动检验科智慧化升级。',
      badgeTitle: '诺瓦智检',
      badgeSub: '成立于2024年',
      milestones: [
        { id: '2007', year: '2007', text: '凯驰医疗集团正式成立，总部设于北京大兴区凯驰大厦。逐步构建集销售、配送、技术支持、科研转化为一体的医疗检验综合服务平台' },
        { id: '2024', year: '2024', text: '成立子公司诺瓦智检，专注检验科AI审核、PBRTQC质控、预测分析及数字孪生等智慧检验产品' },
        { id: 'partnership', year: '重大事件', text: '凯驰医疗集团与北京协和医院达成战略合作，双方共同打造诺瓦智检产品，推动检验科智能化升级' }
      ],
      values: [
        { id: 'ai', title: 'AI 赋能', desc: '自研大模型，AI审核准确率95%' },
        { id: 'security', title: '安全合规', desc: '全链路数据加密，满足等保三级与HIPAA要求' },
        { id: 'ecosystem', title: '开放生态', desc: '标准化接口，无缝对接HIS/LIS等系统' }
      ],
      mission: [
        { id: 'mission', title: '使命', desc: '用AI重塑医学检验智慧，让每一份报告精准、高效、有温度、可信。' },
        { id: 'vision', title: '愿景', desc: '成为领先的智慧检验AI服务商，构建人机数据融合的未来检验生态。' },
        { id: 'values', title: '价值观', desc: '精准为核 医工融合 持续进化 协同共赢 责任担当' }
      ]
    },
    business: {
      eyebrow: 'CORE BUSINESS',
      title: '三大核心业务板块',
      desc: 'AI、PBRTQC、预测与数字孪生三维驱动，构建完整的智慧医院检验平台',
      tabs: [
        {
          id: 'ai-audit',
          en: 'AI审核',
          zh: 'Artificial Intelligence ',
          title: 'AI 审核 —— 让检验结果审核更高效、更安全',
          desc: '千亿参数检验垂类大语言模型，基于深度学习与临床规则引擎，对检验结果进行自动复核、异常识别、参考区间比对及历史趋势分析，辅助检验医师完成结果审核。支持私有化部署与云端调用。',
          features: [
            { id: 'intercept', title: '自动拦截与提示：', text: '对超出危急值、逻辑矛盾、样本状态异常的结果实时标记并触发复检流程' },
            { id: 'reference', title: '动态参考区间：', text: '结合患者年龄、性别、科室等特征动态匹配参考范围，减少误判' },
            { id: 'dashboard', title: '审核效率看板：', text: '统计审核通过率、人工干预频次，持续优化模型' },
            { id: 'multimodal', title: '多模态：', text: '文本+影像+病理联合推理' },
            { id: 'knowledge', title: '知识库：', text: '覆盖2000万篇医学文献+10年真实临床数据' },
            { id: 'lis', title: '与LIS无缝对接：', text: '支持主流检验信息系统接口，实现结果生成-AI初审-人工终审闭环' },
            { id: 'compliance', title: '合规：', text: '支持完全本地化部署，数据不出院' }
          ],
          metrics: [
            { id: 'efficiency', value: '96%', label: '审核效率提升' },
            { id: 'cost', value: '70%', label: '人工审核成本' },
            { id: 'risk', value: '降低', label: '人为疏漏风险' }
          ]
        },
        {
          id: 'pbrtqc',
          en: 'PBRTQC（实时质控）',
          zh: 'Real-time quality control',
          title: 'PBRTQC —— 基于患者数据的实时质控',
          desc: '利用患者检验大数据（Patient-Based Real-Time Quality Control），替代或补充传统质控品方法，实时监测分析全过程的质量漂移。',
          features: [
            { id: 'moving', title: '移动均值法/移动中位数法：', text: '实时计算患者结果移动平均值，自动绘制质控曲线' },
            { id: 'multi', title: '多参数联合监控：', text: '支持对同一分析项目在不同仪器、不同时段、不同试剂批号的性能比对' },
            { id: 'alarm', title: '智能报警规则：', text: '当移动均值超出预设范围时，自动推送异常预警并建议质控动作' },
            { id: 'report', title: '回顾性分析与改进报告：', text: '生成月度/季度质控评价报告，辅助管理层决策' }
          ],
          metrics: [
            { id: 'error', value: '提前发现', label: '系统误差' },
            { id: 'consumption', value: '降低', label: '质控品消耗成本' }
          ]
        },
        {
          id: 'prediction-twin',
          en: '预测与数字孪生',
          zh: 'Prediction and Digital Twinning',
          title: '预测分析 & 数字孪生 —— 驱动检验科智慧决策',
          desc: '融合历史检验数据、设备状态、患者趋势等多源信息，构建检验全流程的数字孪生模型，实现结果预测、资源调度、风险预警。',
          features: [
            { id: 'risk', title: '预测分析 - 疾病风险预测：', text: '基于常规检验指标，辅助评估急性肾损伤、胶毒症、心衰等疾病发生概率' },
            { id: 'flow', title: '预测分析 - 样本流量预测：', text: '预测未来不同时段各检验项目的测试量，为排班、试剂备货提供依据' },
            { id: 'device', title: '预测分析 - 设备故障预测：', text: '分析仪器运行日志与质控异常模式，提前预警潜在故障' },
            { id: 'mapping', title: '数字孪生 - 全流程虚拟映射：', text: '构建从标本采集、运输、上机检测到结果报告的1:1数字孪生体' },
            { id: 'what-if', title: '数字孪生 - What-If沙盘推演：', text: '模拟改变质控规则、增加检测频次、调整人员配置对TAT和合格率的影响' },
            { id: 'ops', title: '数字孪生 - 设备运维孪生：', text: '实时同步仪器状态，优化维护计划，降低非计划停机' },
            { id: 'cockpit', title: '可视化驾驶舱：', text: '为检验科主任提供“检验运营大脑”，一屏掌握质量指标、效率趋势、风险事件' }
          ],
          metrics: [
            { id: 'proactive', value: '主动预测', label: '变被动反应' },
            { id: 'response', value: '缩短', label: '异常响应时间' },
            { id: 'value', value: '挖掘', label: '数据深层价值' }
          ]
        }
      ]
    },
    productServices: {
      eyebrow: 'PRODUCTS & SERVICES',
      title: '产品与服务',
      desc: '覆盖全场景的医检智能产品矩阵，助力医疗机构数字化转型',
      detailLink: '了解详情',
      services: [
        { id: 'hematology', name: '临床血液学检查', badge: '血常规', desc: '基于 NovaMind-M1 多模态大模型的智能审核产品，面向临床血液检测（血常规、凝血、血型）等关键场景，自动解析散点图、反应曲线及指标数据，识别异常细胞群、血小板聚集、及药物干扰激素波动，实现结果智能审核与全流程质控。', points: ['支持血常规、凝血、血型多项指标智能解析', '自动识别异常细胞群及血小板聚集', '结合患者历史与周期实现智能审核', '审核通过率 ≥ 95%，节省约 90% 人工时间'] },
        { id: 'reproduction', name: '辅助生殖', badge: 'IFS', desc: '覆盖 IFS 与辅助生殖全生命周期，数字孪生模型预测全周期指标变化，实现高效安全的辅助生殖检测。', points: ['覆盖卵泡、胚胎、激素等全周期数据管理', '自动化仪器接入与流程控制', '实时质控与异常报警', '支持 CLIA、CAP 等国际认证管理'] },
        { id: 'biochemistry', name: '临床生化/免疫学检查', badge: '生免', desc: '结合深度学习和多模态分析，面向生化与免疫检测场景，实现指标异常智能识别、报告自动生成及质量控制，提升检测效率与准确性。', points: ['自动解析血清、尿液及免疫指标数据', '异常信号智能识别，降低漏诊风险', '支持多种生化与免疫分析仪器接入', '报告自动生成，标准化输出'] },
        { id: 'microbiology', name: '临床微生物检查', badge: '微生物', desc: '基于数字病理与 NovaMind 模型，支持 H&E、IHC 等多种染色及细胞级分析，实现病原体识别与定量分析，助力实验室精细化管理。', points: ['全玻片高分辨率扫描与分析', '病原体及细胞计数准确率 ≥ 99%', '支持多标记免疫组化分析', '自动生成检测报告与质量控制'] },
        { id: 'molecular', name: '临床分子生物学检查', badge: 'PCR 基因测序', desc: '面向新生儿筛查、遗传病检测及肿瘤基因组学的 NovaMind-M1 高通量分子检测平台，提供全流程自动化测序分析与智能报告生成，支持无创产前检测及肿瘤基因组全测序。', points: ['5000+ 遗传位点及突变检测', '无创产前检测 (NIPT) 支持', '肿瘤全基因组测序分析', '自动生成解读报告并支持临床决策'] },
        { id: 'more', name: '更多产品线', badge: '', desc: '面向中小型医疗机构的 SaaS 化智能检验中间件解决方案，快速部署，整合实验室数据与管理流程，实现数据互联、分析智能化和医联体共享。', points: ['开箱即用，无需 IT 运维', '弹性扩容，按需付费', '数据互联互通，支持医联体共享', '快速上线，提升实验室数字化能力'] }
      ]
    },
    products: {
      eyebrow: 'PRODUCT ARCHITECTURE',
      title: '产品架构',
      desc: '以平台底座为基础，向上支撑数据、AI、业务服务与终端应用的完整智能检验体系',
      ariaLabel: '产品架构五层模型',
      layers: [
        { id: 'application', code: 'L1', name: '终端应用层', en: 'Applications', items: [{ id: 'workbench', title: '检验工作台', en: 'Lab Workbench' }, { id: 'analytics', title: '决策分析', en: 'Decision Analytics' }, { id: 'collaboration', title: '协同互认', en: 'Collaboration' }, { id: 'access', title: '开放入口', en: 'Open Access' }] },
        { id: 'business', code: 'L2', name: '业务服务层', en: 'Business Services', items: [{ id: 'domain', title: '领域服务', en: 'Domain Services' }, { id: 'orchestration', title: '会话与编排', en: 'Session & Orchestration' }] },
        { id: 'ai', code: 'L3', name: 'AI 能力平台', en: 'AI Platform', items: [{ id: 'model', title: '模型服务', en: 'Model Services' }, { id: 'knowledge', title: '知识服务', en: 'Knowledge Services' }, { id: 'rules', title: '规则引擎', en: 'Rule Engine' }] },
        { id: 'data', code: 'L4', name: '数据平台', en: 'Data Platform', items: [{ id: 'collection', title: '数据采集', en: 'Data Collection' }, { id: 'storage', title: '数据存储', en: 'Data Storage' }, { id: 'governance', title: '数据治理', en: 'Data Governance' }] },
        { id: 'foundation', code: 'L5', name: '平台底座', en: 'Platform Foundation', items: [{ id: 'security', title: '安全与权限', en: 'Security & Auth' }, { id: 'aiops', title: '智能运维', en: 'AIOps' }] }
      ]
    },
    news: {
      eyebrow: 'NEWS & INSIGHTS',
      title: '新闻资讯',
      desc: '关注智慧检验、医疗 AI 与实验室质量管理前沿动态',
      readMore: '阅读全文',
      detailComingSoon: '《{title}》详情页开发中，敬请期待',
      insights: [
        { id: 'ai-lab', title: 'AI + 检验：精准医学的新引擎', desc: '探讨人工智能如何重塑医学检验流程，提升检测质量与报告效率。', icon: 'el-icon-s-flag', color: 'linear-gradient(135deg,#6c5ce7,#a29bfe)', link: '阅读白皮书' },
        { id: 'pbrtqc-guide', title: 'PBRTQC实时质控落地指南', desc: '从数据清洗、参数选择到报警规则配置，梳理患者数据质控应用路径。', icon: 'el-icon-data-analysis', color: 'linear-gradient(135deg,#0a5c8a,#1a8fc0)', link: '下载报告' },
        { id: 'digital-twin', title: '数字孪生在检验科的实践', desc: '结合真实场景，展示数字孪生如何辅助排班、质控和设备运维决策。', icon: 'el-icon-cpu', color: 'linear-gradient(135deg,#00c9a7,#009e84)', link: '查看案例' }
      ]
    },
    contact: {
      eyebrow: 'CONTACT US',
      title: '携手共创智慧医健未来',
      desc: '无论您是医疗机构、科研院所还是合作伙伴，欢迎与我们联系',
      officeTitle: '全国服务机构',
      info: [
        { id: 'address', icon: 'el-icon-office-building', label: '公司总部', value: '北京市大兴区宏业东路1号院16号楼四层401室' },
        { id: 'email', icon: 'el-icon-message', label: '商务邮箱', value: 'nuowazhijian@163.com' },
        { id: 'response', icon: 'el-icon-time', label: '响应时间', value: '工作日 2 小时内回复，急件请电话联系' }
      ],
      cities: ['北京', '上海', '广州', '深圳', '成都', '武汉', '杭州', '西安', '南京', '重庆', '天津', '郑州']
    },
    footer: {
      desc: '专注检验、医疗、AI融合创新，以科技赋能精准医学，助力每一位患者获得精准、高效的医疗健康服务。',
      socials: [
        { id: 'wechat', name: '微信' },
        { id: 'weibo', name: '微博' },
        { id: 'linkedin', name: 'LinkedIn' },
        { id: 'video', name: '视频号' }
      ],
      linkCols: [
        { id: 'architecture', title: '产品架构', links: ['终端应用层', '业务服务层', 'AI 能力平台', '数据平台', '平台底座'] },
        { id: 'solutions', title: '解决方案', links: ['三甲医院解决方案', '区域医联体平台', '独立医学实验室', '体检中心管理', '科研院所支持', '基层卫生服务'] },
        { id: 'about', title: '关于我们', links: ['公司介绍',  '发展历程', '荣誉资质',  '联系我们'] }
      ],
      
    },
    adminNews: {
      contentAdmin: '内容管理后台',
      newsNav: '新闻资讯',
      backHome: '返回官网',
      eyebrow: 'NEWS CMS',
      title: '新闻资讯管理',
      desc: '维护官网新闻标题、摘要、分类、日期和首页展示状态',
      resetDefault: '恢复默认',
      createNews: '新增新闻',
      date: '日期',
      newsTitle: '新闻标题',
      excerpt: '新闻摘要',
      category: '分类',
      readTime: '阅读时间',
      featured: '首页主推',
      actions: '操作',
      edit: '编辑',
      delete: '删除',
      editNews: '编辑新闻',
      addNews: '新增新闻',
      zhTab: '中文内容',
      enTab: '英文内容',
      publishDate: '发布日期',
      icon: '图标',
      background: '背景色',
      setFeatured: '设为主推新闻',
      cancel: '取消',
      save: '保存',
      datePlaceholder: '选择日期',
      categoryPlaceholder: '如：产品更新',
      enCategoryPlaceholder: 'e.g. Product Updates',
      readTimePlaceholder: '如：3 分钟',
      enReadTimePlaceholder: 'e.g. 3 min',
      iconPlaceholder: '选择图标',
      backgroundPlaceholder: '选择背景',
      saved: '新闻已保存',
      featuredUpdated: '主推新闻已更新',
      deleted: '已删除',
      resetDone: '已恢复默认新闻',
      deleteTitle: '删除新闻',
      confirmDeleteMessage: '确认删除《{title}》？',
      resetTitle: '恢复默认',
      resetMessage: '将恢复为系统默认新闻，当前本地编辑会被清空。',
      languageSwitch: '语言切换',
      backgrounds: {
        deepBlue: '深蓝科技',
        aiPurple: 'AI 紫',
        qcGreen: '质控绿',
        honorGold: '荣誉金',
        insightPurple: '洞察紫'
      },
      validation: {
        zhTitle: '请输入中文新闻标题',
        zhExcerpt: '请输入中文新闻摘要',
        zhCategory: '请输入中文分类',
        zhReadTime: '请输入中文阅读时间',
        enTitle: '请输入英文新闻标题',
        enExcerpt: '请输入英文新闻摘要',
        enCategory: '请输入英文分类',
        enReadTime: '请输入英文阅读时间',
        date: '请选择发布日期',
        icon: '请选择图标',
        background: '请选择背景'
      }
    }
  },
  en: {
    brand: {
      name: 'NovaLab AI'
    },
    nav: {
      items: [
        { id: 'hero', label: 'Home' },
        { id: 'about', label: 'About' },
        { id: 'business', label: 'Business' },
        { id: 'product-services', label: 'Services' },
        { id: 'products', label: 'Architecture' },
        { id: 'news', label: 'News' }
      ],
      contact: 'Contact Us',
      languageSwitch: 'Language switcher',
      locales: [
        { value: 'zh', label: '中文' },
        { value: 'en', label: 'EN' }
      ]
    },
    hero: {
      badge: 'AI Audit + PBRTQC + Predictive Digital Twin',
      titleLine1: 'Reimagining Lab Medicine',
      titleHighlight: 'for an Intelligent Future',
      desc: 'NovaLab AI is driven by artificial intelligence, integrating precision diagnostics and smart healthcare solutions to provide end-to-end intelligent services for hospitals and research institutions.',
      primaryCta: 'Explore Core Business',
      secondaryCta: 'Learn More',
      aiAuditTitle: 'AI Audit',
      aiAuditDesc: 'Intelligent review, efficient detection, trusted results',
      accuracy: 'Accuracy',
      twinTitle: 'Prediction & Digital Twin',
      twinDesc: 'Covers multiple indicators',
      pbrtqcDesc: 'Real-time Quality control',
      scrollHint: 'Scroll Down'
    },
    about: {
      eyebrow: 'ABOUT US',
      titlePrefix: 'Focused on Clinical Lab AI',
      titleHighlight: 'Built with Depth',
      desc: 'Kaichi Medical Group and Peking Union Medical College Hospital have formed a strategic partnership to jointly build NovaLab AI. Leveraging NovaLab AI strengths in technology translation, channel coverage, and engineering services, the collaboration combines expert laboratory rules with AI algorithms and software R&D to create a system centered on AI audit, PBRTQC quality control, predictive analytics, and digital twins for smarter laboratory operations.',
      badgeTitle: 'NovaLab AI',
      badgeSub: 'Founded in 2024',
      milestones: [
        { id: '2007', year: '2007', text: 'Kaichi Medical Group was founded in Beijing Daxing and began building an integrated clinical laboratory service platform spanning sales, distribution, technical support, and research translation.' },
        { id: '2024', year: '2024', text: 'NovaLab AI was established to focus on AI audit, PBRTQC, predictive analytics, and digital twin products for clinical laboratories.' },
        { id: 'partnership', year: 'Milestone', text: 'Kaichi Medical Group and Peking Union Medical College Hospital formed a strategic partnership to accelerate intelligent laboratory upgrades.' }
      ],
      values: [
        { id: 'ai', title: 'AI Empowerment', desc: 'Self-developed models with 95% AI audit accuracy' },
        { id: 'security', title: 'Security & Compliance', desc: 'End-to-end encryption aligned with Level 3 security and HIPAA requirements' },
        { id: 'ecosystem', title: 'Open Ecosystem', desc: 'Standardized interfaces for seamless HIS/LIS integration' }
      ],
      mission: [
        { id: 'mission', title: 'Mission', desc: 'Use AI to reshape medical laboratory intelligence and make every report accurate, efficient, trusted, and human-centered.' },
        { id: 'vision', title: 'Vision', desc: 'Become a leading AI service provider for smart laboratories and build a future ecosystem where people, machines, and data work together.' },
        { id: 'values', title: 'Values', desc: 'Precision, medical-engineering collaboration, continuous evolution, shared success, and responsibility' }
      ]
    },
    business: {
      eyebrow: 'CORE BUSINESS',
      title: 'Three Core Business Areas',
      desc: 'AI, PBRTQC, prediction, and digital twins power a complete smart hospital laboratory platform.',
      tabs: [
        {
          id: 'ai-audit',
          en: 'Artificial Intelligence',
          zh: 'Artificial Intelligence',
          title: 'AI Audit — Faster and Safer Result Review',
          desc: 'A domain-specific large language model for laboratory medicine combines deep learning and clinical rule engines to automatically review results, identify abnormalities, compare reference intervals, analyze historical trends, and assist laboratory physicians. It supports both private deployment and cloud access.',
          features: [
            { id: 'intercept', title: 'Automatic blocking and prompts: ', text: 'Flags critical values, logical conflicts, and abnormal sample states in real time and triggers retesting workflows.' },
            { id: 'reference', title: 'Dynamic reference intervals: ', text: 'Matches reference ranges using age, sex, department, and other patient features to reduce misjudgment.' },
            { id: 'dashboard', title: 'Audit efficiency dashboard: ', text: 'Tracks pass rates and manual intervention frequency to continuously optimize the model.' },
            { id: 'multimodal', title: 'Multimodal reasoning: ', text: 'Combines text, imaging, and pathology for joint inference.' },
            { id: 'knowledge', title: 'Knowledge base: ', text: 'Covers 20 million medical papers and 10 years of real clinical data.' },
            { id: 'lis', title: 'Seamless LIS integration: ', text: 'Connects with mainstream laboratory information systems for result generation, AI pre-review, and final human review.' },
            { id: 'compliance', title: 'Compliance: ', text: 'Supports fully localized deployment so data stays within the hospital.' }
          ],
          metrics: [
            { id: 'efficiency', value: '96%', label: 'Audit efficiency improvement' },
            { id: 'cost', value: '70%', label: 'Manual review cost' },
            { id: 'risk', value: 'Lower', label: 'Human oversight risk' }
          ]
        },
        {
          id: 'pbrtqc',
          en: 'Real-time Quality control',
          zh: 'Real-time Quality control',
          title: 'PBRTQC — Patient-Based Real-Time Quality Control',
          desc: 'Patient-Based Real-Time Quality Control uses large-scale patient laboratory data to complement or replace traditional QC materials and monitor analytical quality drift in real time.',
          features: [
            { id: 'moving', title: 'Moving mean and median methods: ', text: 'Calculates moving averages from patient results in real time and automatically draws QC curves.' },
            { id: 'multi', title: 'Multi-parameter monitoring: ', text: 'Compares performance across instruments, time windows, and reagent lots for the same analyte.' },
            { id: 'alarm', title: 'Intelligent alert rules: ', text: 'Pushes alerts and recommended QC actions when moving averages exceed preset ranges.' },
            { id: 'report', title: 'Retrospective analysis and reports: ', text: 'Generates monthly and quarterly QC evaluation reports for management decisions.' }
          ],
          metrics: [
            { id: 'error', value: 'Early', label: 'Systematic error detection' },
            { id: 'consumption', value: 'Lower', label: 'QC material consumption' }
          ]
        },
        {
          id: 'prediction-twin',
          en: 'Prediction and Digital Twinning',
          zh: 'Prediction and Digital Twinning',
          title: 'Predictive Analytics & Digital Twin — Smarter Lab Decisions',
          desc: 'By integrating historical results, equipment status, patient trends, and other data sources, the platform builds a digital twin of laboratory workflows for prediction, scheduling, and risk warning.',
          features: [
            { id: 'risk', title: 'Disease risk prediction: ', text: 'Uses routine laboratory indicators to assess risks such as acute kidney injury, sepsis, and heart failure.' },
            { id: 'flow', title: 'Sample volume prediction: ', text: 'Forecasts future testing volume by time period to support staffing and reagent planning.' },
            { id: 'device', title: 'Equipment failure prediction: ', text: 'Analyzes instrument logs and QC patterns to warn of potential failures in advance.' },
            { id: 'mapping', title: 'End-to-end virtual mapping: ', text: 'Builds a 1:1 digital twin from sample collection and transport to testing and report release.' },
            { id: 'what-if', title: 'What-if simulation: ', text: 'Simulates how QC rules, testing frequency, and staffing changes affect TAT and pass rates.' },
            { id: 'ops', title: 'Equipment operations twin: ', text: 'Synchronizes instrument status in real time to optimize maintenance and reduce unplanned downtime.' },
            { id: 'cockpit', title: 'Visual command center: ', text: 'Gives laboratory directors a single view of quality indicators, efficiency trends, and risk events.' }
          ],
          metrics: [
            { id: 'proactive', value: 'Proactive', label: 'Prediction over reaction' },
            { id: 'response', value: 'Shorter', label: 'Exception response time' },
            { id: 'value', value: 'Deeper', label: 'Data value mining' }
          ]
        }
      ]
    },
    productServices: {
      eyebrow: 'PRODUCTS & SERVICES',
      title: 'Products & Services',
      desc: 'A full-scenario intelligent laboratory product matrix that supports digital transformation for healthcare institutions.',
      detailLink: 'Learn More',
      services: [
        { id: 'hematology', name: 'Clinical Hematology Testing', badge: 'CBC', desc: 'Powered by the NovaMind-M1 multimodal model, this intelligent audit product serves key hematology scenarios such as CBC, coagulation, and blood typing. It automatically analyzes scatterplots, reaction curves, and indicator data to identify abnormal cell populations, platelet aggregation, and drug-related hormone fluctuations.', points: ['Supports intelligent analysis of CBC, coagulation, and blood typing indicators', 'Automatically detects abnormal cell populations and platelet aggregation', 'Combines patient history and cycles for intelligent review', 'Achieves ≥95% audit pass rate and saves about 90% manual time'] },
        { id: 'reproduction', name: 'Assisted Reproduction', badge: 'IFS', desc: 'Covers IFS and the full assisted reproduction lifecycle, using digital twin models to predict indicator changes across the entire cycle for efficient and safe reproductive testing.', points: ['Manages follicle, embryo, hormone, and lifecycle data', 'Connects automated instruments and workflow control', 'Provides real-time QC and abnormal alerts', 'Supports CLIA, CAP, and other international certification management'] },
        { id: 'biochemistry', name: 'Clinical Biochemistry & Immunology', badge: 'Biochem & Immuno', desc: 'Combining deep learning and multimodal analysis for biochemistry and immunology testing, the solution identifies abnormal indicators, generates reports, and strengthens quality control.', points: ['Automatically analyzes serum, urine, and immunology indicators', 'Detects abnormal signals to reduce missed diagnosis risk', 'Supports integration with multiple biochemistry and immunoassay analyzers', 'Generates standardized reports automatically'] },
        { id: 'microbiology', name: 'Clinical Microbiology Testing', badge: 'Microbiology', desc: 'Based on digital pathology and NovaMind models, this solution supports H&E, IHC, and cell-level analysis to identify pathogens and quantify results for refined laboratory management.', points: ['High-resolution whole-slide scanning and analysis', '≥99% accuracy for pathogen and cell counting', 'Supports multi-marker immunohistochemistry analysis', 'Automatically generates testing reports and QC outputs'] },
        { id: 'molecular', name: 'Clinical Molecular Biology Testing', badge: 'PCR & Sequencing', desc: 'NovaMind-M1 high-throughput molecular platform supports newborn screening, genetic disease testing, and oncology genomics with automated sequencing analysis and intelligent report generation.', points: ['Detects 5,000+ genetic loci and mutations', 'Supports non-invasive prenatal testing (NIPT)', 'Analyzes tumor whole-genome sequencing', 'Generates interpretation reports for clinical decisions'] },
        { id: 'more', name: 'More Product Lines', badge: '', desc: 'A SaaS-based intelligent laboratory middleware solution for small and medium-sized medical institutions, enabling fast deployment, data integration, intelligent analytics, and regional collaboration.', points: ['Ready to use with no IT operations burden', 'Elastic scaling with pay-as-you-go usage', 'Interoperable data sharing for medical alliances', 'Rapid launch to improve laboratory digitization'] }
      ]
    },
    products: {
      eyebrow: 'PRODUCT ARCHITECTURE',
      title: 'Product Architecture',
      desc: 'Built on a platform foundation that supports data, AI, business services, and terminal applications for an intelligent laboratory system.',
      ariaLabel: 'Five-layer product architecture model',
      layers: [
        { id: 'application', code: 'L1', name: 'Application Layer', en: 'Applications', items: [{ id: 'workbench', title: 'Lab Workbench', en: 'Lab Workbench' }, { id: 'analytics', title: 'Decision Analytics', en: 'Decision Analytics' }, { id: 'collaboration', title: 'Mutual Recognition', en: 'Collaboration' }, { id: 'access', title: 'Open Access', en: 'Open Access' }] },
        { id: 'business', code: 'L2', name: 'Business Services', en: 'Business Services', items: [{ id: 'domain', title: 'Domain Services', en: 'Domain Services' }, { id: 'orchestration', title: 'Session & Orchestration', en: 'Session & Orchestration' }] },
        { id: 'ai', code: 'L3', name: 'AI Platform', en: 'AI Platform', items: [{ id: 'model', title: 'Model Services', en: 'Model Services' }, { id: 'knowledge', title: 'Knowledge Services', en: 'Knowledge Services' }, { id: 'rules', title: 'Rule Engine', en: 'Rule Engine' }] },
        { id: 'data', code: 'L4', name: 'Data Platform', en: 'Data Platform', items: [{ id: 'collection', title: 'Data Collection', en: 'Data Collection' }, { id: 'storage', title: 'Data Storage', en: 'Data Storage' }, { id: 'governance', title: 'Data Governance', en: 'Data Governance' }] },
        { id: 'foundation', code: 'L5', name: 'Platform Foundation', en: 'Platform Foundation', items: [{ id: 'security', title: 'Security & Auth', en: 'Security & Auth' }, { id: 'aiops', title: 'AIOps', en: 'AIOps' }] }
      ]
    },
    news: {
      eyebrow: 'NEWS & INSIGHTS',
      title: 'News & Insights',
      desc: 'Follow the latest in smart laboratories, medical AI, and laboratory quality management.',
      readMore: 'Read More',
      detailComingSoon: 'The detail page for "{title}" is coming soon.',
      insights: [
        { id: 'ai-lab', title: 'AI + Laboratory: A New Engine for Precision Medicine', desc: 'Explores how AI reshapes laboratory workflows and improves testing quality and reporting efficiency.', icon: 'el-icon-s-flag', color: 'linear-gradient(135deg,#6c5ce7,#a29bfe)', link: 'Read White Paper' },
        { id: 'pbrtqc-guide', title: 'PBRTQC Implementation Guide', desc: 'A practical path from data cleaning and parameter selection to alert rule configuration.', icon: 'el-icon-data-analysis', color: 'linear-gradient(135deg,#0a5c8a,#1a8fc0)', link: 'Download Report' },
        { id: 'digital-twin', title: 'Digital Twin Practices in Clinical Labs', desc: 'Shows how digital twins support scheduling, QC, and equipment operations decisions in real scenarios.', icon: 'el-icon-cpu', color: 'linear-gradient(135deg,#00c9a7,#009e84)', link: 'View Case Study' }
      ]
    },
    contact: {
      eyebrow: 'CONTACT US',
      title: 'Build the Future of Smart Healthcare Together',
      desc: 'Whether you are a healthcare institution, research organization, or partner, we welcome your message.',
      officeTitle: 'Service Network',
      info: [
        { id: 'address', icon: 'el-icon-office-building', label: 'Headquarters', value: 'Room 401, Building 16, No. 1 Hongye East Road, Daxing District, Beijing' },
        { id: 'email', icon: 'el-icon-message', label: 'Business Email', value: 'nuowazhijian@163.com' },
        { id: 'response', icon: 'el-icon-time', label: 'Response Time', value: 'Replies within 2 working hours; urgent requests can contact us by phone.' }
      ],
      cities: ['Beijing', 'Shanghai', 'Guangzhou', 'Shenzhen', 'Chengdu', 'Wuhan', 'Hangzhou', 'Xi’an', 'Nanjing', 'Chongqing', 'Tianjin', 'Zhengzhou']
    },
    footer: {
      desc: 'Focused on laboratory medicine, healthcare, and AI innovation, we empower precision medicine with technology and help every patient receive accurate and efficient care.',
      socials: [
        { id: 'wechat', name: 'WeChat' },
        { id: 'weibo', name: 'Weibo' },
        { id: 'linkedin', name: 'LinkedIn' },
        { id: 'video', name: 'Video Channel' }
      ],
      linkCols: [
        { id: 'architecture', title: 'Architecture', links: ['Application Layer', 'Business Services', 'AI Platform', 'Data Platform', 'Platform Foundation'] },
        { id: 'solutions', title: 'Solutions', links: ['Tertiary Hospitals', 'Regional Medical Alliances', 'Independent Medical Labs', 'Health Check Centers', 'Research Institutes', 'Primary Care Services'] },
        { id: 'about', title: 'About Us', links: ['Company Profile',  'Milestones', 'Honors', 'Careers', ] }
      ],
    },
    adminNews: {
      contentAdmin: 'Content Management',
      newsNav: 'News',
      backHome: 'Back to Website',
      eyebrow: 'NEWS CMS',
      title: 'News Management',
      desc: 'Maintain website news titles, excerpts, categories, dates, and featured status.',
      resetDefault: 'Reset Defaults', 
      createNews: 'New Article',
      date: 'Date',
      newsTitle: 'Title',
      excerpt: 'Excerpt',
      category: 'Category',
      readTime: 'Read Time',
      featured: 'Featured',
      actions: 'Actions',
      edit: 'Edit',
      delete: 'Delete',
      editNews: 'Edit Article',
      addNews: 'New Article',
      zhTab: 'Chinese Content',
      enTab: 'English Content',
      publishDate: 'Publish Date',
      icon: 'Icon',
      background: 'Background',
      setFeatured: 'Set as featured article',
      cancel: 'Cancel',
      save: 'Save',
      datePlaceholder: 'Select date',
      categoryPlaceholder: '例如：产品更新',
      enCategoryPlaceholder: 'e.g. Product Updates',
      readTimePlaceholder: '例如：3 分钟',
      enReadTimePlaceholder: 'e.g. 3 min',
      iconPlaceholder: 'Select icon',
      backgroundPlaceholder: 'Select background',
      saved: 'News saved',
      featuredUpdated: 'Featured article updated',
      deleted: 'Deleted',
      resetDone: 'Default news restored',
      deleteTitle: 'Delete Article',
      confirmDeleteMessage: 'Delete "{title}"?',
      resetTitle: 'Reset Defaults',
      resetMessage: 'This will restore the default news and clear local edits.',
      languageSwitch: 'Language switcher',
      backgrounds: {
        deepBlue: 'Deep Blue Tech',
        aiPurple: 'AI Purple',
        qcGreen: 'QC Green',
        honorGold: 'Honor Gold',
        insightPurple: 'Insight Purple'
      },
      validation: {
        zhTitle: 'Please enter the Chinese title',
        zhExcerpt: 'Please enter the Chinese excerpt',
        zhCategory: 'Please enter the Chinese category',
        zhReadTime: 'Please enter the Chinese read time',
        enTitle: 'Please enter the English title',
        enExcerpt: 'Please enter the English excerpt',
        enCategory: 'Please enter the English category',
        enReadTime: 'Please enter the English read time',
        date: 'Please select a publish date',
        icon: 'Please select an icon',
        background: 'Please select a background'
      }
    }
  }
}
